import React, { useState } from "react";
import "../styling/SignUp.css";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import BookingHeader from "./clientPortal/BookingHeader";
// --- 1. Import icons ---
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Password = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // --- 2. Add state for visibility toggles ---
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const formData = location.state || {};

  const isPasswordValid = (password) => {
    const minLength = /.{8,}/;
    const lowercase = /[a-z]/;
    const uppercase = /[A-Z]/;
    const numberOrSymbol = /[\d\W]/;

    return (
      minLength.test(password) &&
      lowercase.test(password) &&
      uppercase.test(password) &&
      numberOrSymbol.test(password)
    );
  };
  
  const handleSubmit = async () => {
    if (isSubmitting) return; 

    if (!password || !confirmPassword) {
      alert("Please fill in both password fields");
      return;
    }

    // --- 3. Check for match logic (already present but kept for clarity) ---
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    if (!isPasswordValid(password)) {
      alert("Password must follow given requirements");
      return;
    }

    setIsSubmitting(true); 

    try {
      const response = await axios.post( 
        `${process.env.REACT_APP_API_URL}/business-user/onboard`,
        {
          email: formData.email,
          password: password,
          name: formData.firstName,
          lastName: formData.lastName,
          phone: formData.phone,
        },
        { withCredentials: true }
      );

      navigate("/checkMail");
    } catch (err) {
      console.log(err);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false); 
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div style={{ height: "auto" }}>
      <BookingHeader />
      <div className="login-page-container">
        <div className="login-business" style={{ minHeight: "626px" }}>
          <div className="login-content" style={{ marginBottom: "30px" }}>
            <h1 style={{ fontSize: "24px", color: "#000000", textAlign: "center", fontWeight: "bold", marginTop: "35px", marginBottom: "5px" }}>
              Try BoothBloom free for 7 days
            </h1>
            <div style={{ paddingLeft: "1%", color: "#625C73", textAlign: 'center' }}>
              <p style={{ marginTop: "0px", fontSize: "15px" }}>No Credit Card Required</p>
            </div>

            {/* --- PASSWORD INPUT --- */}
            <div style={{ position: 'relative', width: '100%' }}>
              <input
                placeholder="Password"
                type={showPass ? "text" : "password"}
                className="login-input"
                style={{
                  border: "1px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                  height: "50px",
                  boxSizing: 'border-box',
                  color: "#625C73",
                }}
                value={password} // Fixed: Corrected to bind to 'password'
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <span
                onClick={() => setShowPass(!showPass)}
                style={{
                  position: 'absolute', 
                  paddingRight: '11px',   // Position it relative to the wrapper
                  right: '0px',           // Adjust horizontal position
                  top: '64%',              // Move it 50% down
                  transform: 'translateY(-50%)', // Center it vertically
                  cursor: 'pointer',       // Show it's clickable
                  color: '#555'             // Optional: style the icon color
                }}
              >
                {showPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div style={{ color: "#625C73", fontWeight: '500', marginTop: '10px', display: 'flex' }}>
              Password Requirements:
            </div>

            <div style={{ width: "80%" }}>
              <ul className="password-requirements-list">
                <li style={{ color: "#625C73", fontWeight: "350" }}>At least 8 characters</li>
                <li style={{ color: "#625C73", fontWeight: "350" }}>One lowercase letter</li>
                <li style={{ color: "#625C73", fontWeight: "350" }}>One uppercase letter</li>
                <li style={{ color: "#625C73", fontWeight: "350" }}>One number or symbol</li>
              </ul>
            </div>

            {/* --- CONFIRM PASSWORD INPUT --- */}
            <div style={{ position: 'relative', width: '100%', marginTop: "10px" }}>
              <input
                placeholder="Confirm Password"
                className="login-input"
                type={showConfirmPass ? "text" : "password"}
                style={{
                  border: "1px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                  height: "50px",
                  color: "#625C73",
                  boxSizing: 'border-box'
                }}
                value={confirmPassword} // Fixed: Corrected to bind to 'confirmPassword'
                onChange={(e) => setConfirmPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <span
                onClick={() => setShowConfirmPass(!showConfirmPass)}
                style={{
                  position: 'absolute', 
                  paddingRight: '11px',   // Position it relative to the wrapper
                  right: '0px',           // Adjust horizontal position
                  top: '64%',              // Move it 50% down
                  transform: 'translateY(-50%)', // Center it vertically
                  cursor: 'pointer',       // Show it's clickable
                  color: '#555'             // Optional: style the icon color
                }}
              >
                {showConfirmPass ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button
              style={{
                marginTop: "35px",
                height: "40px",
                width: "100%",
                background: "linear-gradient(to right, #1C1154, #211074, #260F99 )",
                border: "1px solid #43425D ",
                color: "#FFFFFF",
                fontSize: "17px",
                fontWeight: "450",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                opacity: isSubmitting ? 0.7 : 1,
              }}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Next >"}
            </button>

            <div style={{ paddingLeft: "5%", color: "#545454", marginTop: "30px", textAlign: 'center' }}>
              <p>
                Go Back to{" "}
                <Link to="/login">
                  <span style={{ textDecoration: "underline", color: "#545454" }}>login page</span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Password;